import * as React from "react";
import {str} from "util/TextHelper";

export class EmptyPane extends React.Component {
	render() {
		return <div className="Empty-Pane">
			{str("EMPTY_MESSAGE")}
		</div>;
	}
}